export const gameData = {
  SinglePlayer: [
    { name: "Brick Break", imgSrc: "/images/game1.jpg", path: "BrickBreak" },
    {
      name: "Image Slide Puzzle",
      imgSrc: "/images/game2.jpg",
      path: "ImageSlidePuzzle",
    },
    { name: "Ball Fall", imgSrc: "/images/game3.jpg", path: "BallFall" },
    { name: "TicTacToe", imgSrc: "/images/game3.jpg", path: "TicTacToe" },
    {
      name: "Super TicTacToe",
      imgSrc: "/images/game3.jpg",
      path: "SuperTicTacToe",
    },
  ],
  MultiPlayer: [
    {
      name: "Chess",
      imgSrc: "/images/game1.jpg",
      path: "Chess",
      maxPlayers: 2,
    },
    { name: "Whot", imgSrc: "/images/game2.jpg", path: "Whot", maxPlayers: 4 },
    {
      name: "TicTacToe",
      imgSrc: "/images/game2.jpg",
      path: "TicTacToe",
      maxPlayers: 2,
    },
    {
      name: "Super TicTacToe",
      imgSrc: "/images/game3.jpg",
      path: "SuperTicTacToe",
      maxPlayers: 2,
    },
  ],
};
